<div class="json-tree">
  <button pButton severity="secondary" (click)="copyJson()">Copiar</button>

  <ng-container *ngIf="data && (isArray(data) || isObject(data))">
    <span *ngIf="isArray(data)">[</span>
    <span *ngIf="isObject(data)">{{ "{" }}</span>

    <ul>
      <li *ngFor="let key of data | keyvalue; let last = last">
        <ng-container *ngIf="isObject(data)">
          <strong>"{{ key.key }}": </strong>
        </ng-container>

        <ng-container
          *ngIf="isArray(key.value) || isObject(key.value); else value"
        >
          <app-json-tree [data]="key.value"></app-json-tree>
        </ng-container>

        <ng-template #value> "{{ key.value }}" </ng-template>

        <span *ngIf="!last">,</span>
      </li>
    </ul>

    <span *ngIf="isArray(data)">]</span>
    <span *ngIf="isObject(data)">{{ "}" }}</span>
  </ng-container>
</div>


